import { Control, FieldValues, Path, useController } from "react-hook-form";
import styled, { css } from "styled-components";

import ValidationMessage from "@/components/Forms/ValidationMessage";
import { VideoFramesExportType } from "@/utils/enums";
import Text from "@/components/Text";

const Options = styled.div`
  display: flex;
  align-items: center;
`;

const Dot = styled.div<{ $active: boolean }>`
  margin-right: 8px;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 8px;
  width: 16px;
  height: 16px;
  position: relative;

  ${({ theme, $active }) =>
    $active &&
    css`
      border-color: ${theme.colors.purpleLighter};
      &::after {
        content: "";
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;
        background: ${theme.colors.purpleLighter};
        border-radius: 8px;
        width: 8px;
        height: 8px;
      }
    `}
`;

const Option = styled(Text)`
  display: inline-flex;
  align-items: center;
  margin-right: 24px;

  &:hover {
    ${Dot} {
      border-color: ${({ theme }) => theme.colors.purpleLighter};
    }
  }
`;

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
}

const ExportTypeField = <T extends FieldValues>({
  control,
  name,
}: Props<T>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    control,
    name,
  });
  return (
    <div>
      <Options>
        <Option
          as="button"
          $type="smallHeadline"
          type="button"
          onClick={() => onChange(VideoFramesExportType.PART_VIDEO)}
        >
          <Dot $active={value === VideoFramesExportType.PART_VIDEO} />
          Part of video
        </Option>
        <Option
          as="button"
          $type="smallHeadline"
          type="button"
          onClick={() => onChange(VideoFramesExportType.FULL_VIDEO)}
        >
          <Dot $active={value === VideoFramesExportType.FULL_VIDEO} />
          Full video
        </Option>
      </Options>
      {!!error && <ValidationMessage>{error.message}</ValidationMessage>}
    </div>
  );
};

export default ExportTypeField;
